import React from "react";
import { Box } from "@mui/material";
import { AdviceIcon } from "components/icons/AdviceIcon";

interface props {
  hintMessage: string;
}

const Footer: React.FC<props> = ({ hintMessage }) => {
  return (
    <Box
      display="flex"
      alignItems="flex-end"
      position="fixed"
      height="10vh"
      right={16}
      bottom={4}
    >
      <Box
        ml={1}
        bgcolor="white"
        border={4}
        display={"flex"}
        alignItems="center"
        justifyContent={"center"}
        flexDirection={"row"}
        fontWeight="bold"
        sx={{
          width: { xs: "80%", md: "480px" },
          px: { xs: 1, md: 3 },
          py: { xs: "4px", md: "8px" },
          mr: { xs: 0, md: 1 },
          mb: { xs: 2.5, md: 6.5 },
          fontSize: { xs: 10, md: 18 },
          borderRadius: { xs: 4, md: 6 },
        }}
      >
        <Box>
          <Box
            fontFamily="yasashisa"
            sx={{
              mt: { xs: "2px", md: 1 },
            }}
          >
            {hintMessage}
          </Box>
        </Box>
      </Box>
      <Box
        mb="-4px"
        sx={{
          width: { xs: 64, md: "12vh" },
          ml: { xs: 0.5, md: "auto" },
        }}
      >
        <AdviceIcon />
      </Box>
    </Box>
  );
};

export default Footer;
